import { CanvasToolbarButton } from './CanvasToolbarButton';
import { useCanvasFreeElementContext } from '../../../../sweep-canvas/canvas-element-tool/CanvasFreeElementContext';
import { Section } from '@sweep-io/sweep-design/dist/icons/Section';
import { useCanvasFreeElementToolbarButtonBehavior } from './useCanvasFreeElementToolbarButtonBehavior';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';
import { useCallback } from 'react';

export const CanvasSectionsToolbarButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const { createSectionActive, setCreateElementActive } = useCanvasFreeElementContext();
  const { canvasSections } = useFeatureToggle();
  const setCreateSectionActive = useCallback(
    (active: boolean) => setCreateElementActive(active ? 'section' : null),
    [setCreateElementActive],
  );

  const { handleToggle } = useCanvasFreeElementToolbarButtonBehavior({
    createIsActive: createSectionActive,
    setCreateIsActive: setCreateSectionActive,
    buttonId: 'sections',
  });

  if (!canvasSections) {
    return null;
  }

  return (
    <CanvasToolbarButton
      tooltip="New section"
      onToggle={handleToggle}
      pressed={createSectionActive}
      disabled={isDisabled}
    >
      <Section />
    </CanvasToolbarButton>
  );
};
